export class QueryString {
  static getURLSearchParams(): URLSearchParams {
    const path: string = window.location.search.substring(1);

    return new URLSearchParams(path);
  }

  static get(key: string): string | null {
    const params = QueryString.getURLSearchParams();

    return params.get(key);
  }

  static stringify(params: Dictionary<string>): string {
    const queryParams = new URLSearchParams(params as Dictionary<string>);
    queryParams.sort();

    return queryParams.toString();
  }
}
